import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addEmoji,
  deleteEmoji,
  getEmoji,
} from "store/services/dataManagement/emoji";
import { uploadFile } from "store/services/utilities";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

// Get All Emojis
export const GetAllEmojiAction = createAsyncThunk(
  "emoji/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getEmoji(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Delete Emoji
export const DeleteEmojiAction = createAsyncThunk(
  "emoji/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteEmoji(rest);
      if (res.status === 1) {
        const response = await getEmoji(filter);
        if (response.status === 1) {
          return fulfillWithValue(response);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// Add Emoji
export const AddEmojiAction = createAsyncThunk(
  "emoji/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { file, onSuccess, onError, ...rest } = payload;
    // console.log(payload);
    try {
      // Handle file upload if exists
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file,
          uploadFor: "emoji", // specify purpose
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message }),
          );
          return rejectWithValue(uploadFilesResponse);
        }
        
        rest.file = uploadFilesResponse.response.urls[0].file_url;
      }
       
      // Create emoji
      const res = await addEmoji(rest);
      console.log(res);

      if (res.status === 1) {
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        // dispatch(getEmoji()); // refresh emoji list
        return fulfillWithValue(res);
      }

      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error.response.data.statusCode)
            : error.message,
        }),
      );
      if (onError) onError();
      return rejectWithValue(error);
    }
  },
);
